import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitosolapurcab() {



    const cardData = {





keyword: "Mumbai to Solapur Cab",

headingDescription: "Shreesha Tours & Travels offers comfortable and reliable Mumbai to Solapur Cab Service for family trips, business travel, pilgrimage tours, corporate transportation, one-way journeys, round trips, and long-distance travel. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options to ensure a safe and convenient journey from Mumbai to Solapur. With experienced drivers, well-maintained vehicles, transparent pricing, doorstep pickup, flexible travel plans, and 24/7 customer support, we make your journey smooth and hassle-free. Whether you are visiting Solapur for religious purposes, business requirements, family functions, or exploring nearby attractions, Shreesha Tours & Travels provides dependable Mumbai to Solapur cab booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Siddheshwar Temple Solapur",
    description: "Siddheshwar Temple is one of Solapur's most famous religious attractions dedicated to Lord Siddheshwar. The temple and lake surroundings attract devotees and tourists throughout the year."
  },
  {
    title: "Akkalkot Swami Samarth Temple",
    description: "Akkalkot is a renowned pilgrimage destination near Solapur, famous for Shri Swami Samarth Maharaj Temple. Devotees from across Maharashtra visit this sacred place regularly."
  },
  {
    title: "Pandharpur Vitthal Temple",
    description: "Pandharpur is one of Maharashtra's most important pilgrimage destinations, known for Shri Vitthal Rukmini Temple and the famous Wari pilgrimage tradition."
  },
  {
    title: "Tuljapur Bhavani Temple",
    description: "Tuljapur is famous for Tulja Bhavani Temple, one of Maharashtra's most respected Shakti Peetha destinations. It is a major pilgrimage place visited by devotees throughout the year."
  },
  {
    title: "Ujani Dam Solapur",
    description: "Ujani Dam is a scenic destination near Solapur known for bird watching, boating, and beautiful water views. It is a popular spot for nature lovers and weekend travelers."
  },
  {
    title: "Great Indian Bustard Sanctuary",
    description: "The Great Indian Bustard Sanctuary near Solapur is known for wildlife conservation and natural landscapes. It attracts bird watchers and nature enthusiasts."
  },
  {
    title: "Nannaj Wildlife Sanctuary",
    description: "Nannaj Wildlife Sanctuary is a peaceful nature destination near Solapur, famous for grasslands, birds, and wildlife experiences."
  },
  {
    title: "Ganagapur",
    description: "Ganagapur is a famous spiritual destination near Solapur known for the Nirgun Dattatreya Temple. It is an important pilgrimage place for devotees of Lord Dattatreya."
  },
  {
    title: "Shri Kshetra Mangalwedha",
    description: "Mangalwedha is a historic and religious town near Solapur associated with Sant Damaji Maharaj and Maharashtra's spiritual traditions."
  },
  {
    title: "Barshi",
    description: "Barshi is a nearby destination known for Bhagwant Temple, cultural heritage, and religious importance. It is a popular place for visitors exploring the Solapur region."
  }
],




"services": [
  {
    "name": "Mumbai to Solapur Cab",
    "description": "Book Mumbai to Solapur Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Enjoy a smooth journey from Mumbai to Solapur with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options suitable for family trips, business travel, religious visits, and long-distance journeys."
  },
  {
    "name": "Mumbai to Solapur Taxi",
    "description": "Choose Mumbai to Solapur Taxi for convenient and affordable road travel with experienced drivers and comfortable vehicles. Get doorstep pickup, clean AC cars, transparent pricing, and reliable taxi services for personal, corporate, and family transportation needs."
  },
  {
    "name": "Mumbai to Solapur Cab Service",
    "description": "Book Mumbai to Solapur Cab Service for dependable long-distance transportation with trained chauffeurs and premium vehicles. Our cab services provide comfortable travel solutions for family tours, business trips, temple visits, and private journeys between Mumbai and Solapur."
  },
  {
    "name": "Mumbai to Solapur Taxi Service",
    "description": "Hire Mumbai to Solapur Taxi Service for smooth interstate travel with professional drivers and well-maintained cars. Enjoy flexible booking options, comfortable seating, affordable fares, and reliable taxi facilities for your journey."
  },
  {
    "name": "Mumbai to Solapur Cab Booking",
    "description": "Complete Mumbai to Solapur Cab Booking easily with quick confirmation and multiple vehicle choices. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your group size and enjoy a comfortable travel experience."
  },
  {
    "name": "Mumbai to Solapur Car Rental",
    "description": "Choose Mumbai to Solapur Car Rental for chauffeur-driven vehicles designed for comfortable outstation travel. Enjoy spacious cars, experienced drivers, flexible rental plans, and affordable packages for business trips, family tours, and personal journeys."
  },
  {
    "name": "Mumbai to Solapur Taxi Fare",
    "description": "Check Mumbai to Solapur Taxi Fare with transparent pricing and affordable travel options. Get comfortable cab services with professional chauffeurs, clean vehicles, and flexible packages without hidden charges."
  },
  {
    "name": "Mumbai to Solapur One Way Cab",
    "description": "Book Mumbai to Solapur One Way Cab for convenient drop taxi service without return fare charges. Travel comfortably with skilled drivers, clean vehicles, and flexible pickup facilities from Mumbai to Solapur."
  },
  {
    "name": "Mumbai to Solapur Round Trip Taxi",
    "description": "Reserve Mumbai to Solapur Round Trip Taxi for complete return travel with flexible timings and comfortable vehicles. Ideal for family visits, business travel, sightseeing, and extended stays with reliable chauffeur-driven service."
  },
  {
    "name": "Mumbai Airport to Solapur Cab",
    "description": "Book Mumbai Airport to Solapur Cab for smooth airport transfer and long-distance travel services. Enjoy timely pickup, luggage-friendly vehicles, professional drivers, and comfortable transportation from Mumbai Airport to Solapur."
  },
  {
    "name": "Mumbai to Solapur Outstation Cab",
    "description": "Choose Mumbai to Solapur Outstation Cab for safe and reliable long-distance transportation with premium vehicles and experienced chauffeurs. Perfect for personal travel, corporate journeys, family trips, and outstation requirements."
  },
  {
    "name": "Mumbai to Solapur Innova Cab",
    "description": "Book Mumbai to Solapur Innova Cab for spacious and comfortable travel with premium seating and extra luggage space. Ideal for families and groups looking for a reliable vehicle for long-distance journeys."
  },
  {
    "name": "Mumbai to Solapur Ertiga Cab",
    "description": "Reserve Mumbai to Solapur Ertiga Cab for affordable group transportation with comfortable interiors and smooth performance. Suitable for families and small groups planning a convenient journey from Mumbai to Solapur."
  },
  {
    "name": "Mumbai to Solapur Private Taxi",
    "description": "Hire Mumbai to Solapur Private Taxi for personalized travel with a dedicated vehicle and professional chauffeur. Enjoy privacy, flexible routes, comfortable seating, and a peaceful journey for business or personal transportation."
  },
  {
    "name": "Best Mumbai Solapur Cab Service",
    "description": "Choose the Best Mumbai Solapur Cab Service for safe, comfortable, and affordable outstation travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, and reliable service for family trips, corporate journeys, airport transfers, and long-distance travel between Mumbai and Solapur."
  }
],
"tableData": [
  ["Mumbai to Solapur Cab", "Mumbai to Solapur Taxi"],
  ["Mumbai to Solapur Cab Service", "Mumbai to Solapur Taxi Service"],
  ["Mumbai to Solapur Cab Booking", "Mumbai to Solapur Car Rental"],
  ["Mumbai to Solapur Taxi Fare", "Mumbai to Solapur One Way Cab"],
  ["Mumbai to Solapur Round Trip Taxi", "Mumbai Airport to Solapur Cab"],
  ["Mumbai to Solapur Outstation Cab", "Mumbai to Solapur Innova Cab"],
  ["Mumbai to Solapur Ertiga Cab", "Mumbai to Solapur Private Taxi"],
  ["Best Mumbai Solapur Cab Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Solapur Cab Service",
    WhyChoosedescription: "Shreesha Travels provides comfortable Mumbai to Solapur cab services for business travellers, families, students, and personal journeys. Enjoy a smooth road trip with professional chauffeurs, flexible booking options, and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Convenient Travel Between Mumbai & Solapur",
    WhyChoosedescription: "Travel comfortably from Mumbai to Solapur with a private cab service designed for hassle-free long-distance transportation, whether you are travelling for work, family visits, or exploring Maharashtra destinations."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options for Every Journey",
    WhyChoosedescription: "Select from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles according to your group size and comfort needs."
  },
  {
    WhyChooseheading: "Suitable for Family Trips & Business Travel",
    WhyChoosedescription: "Our Mumbai to Solapur taxis are ideal for family visits, corporate travel, industrial tours, educational trips, medical travel, and customized Maharashtra road journeys."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Cabs",
    WhyChoosedescription: "Choose a one-way cab for direct travel to Solapur or book a round-trip package with flexible return timing and personalized travel arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Maharashtra Highways",
    WhyChoosedescription: "Our professional chauffeurs are familiar with Maharashtra routes and ensure safe driving, timely service, and a comfortable journey from Mumbai to Solapur."
  },
  {
    WhyChooseheading: "Comfortable Cars for Long Distance Travel",
    WhyChoosedescription: "Every vehicle is regularly serviced, cleaned, air-conditioned, and inspected before departure to provide passengers with a reliable and enjoyable travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Solapur Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, quick booking support, comfortable vehicles, and dependable chauffeur-driven transportation for your Mumbai to Solapur journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Solapur cab for one-way travel?",
    answer: "Yes, one-way cab services are available for passengers who need direct transportation from Mumbai to Solapur."
  },
  {
    question: "Which cars are available for Mumbai to Solapur cab booking?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Is Mumbai to Solapur taxi service suitable for families?",
    answer: "Yes, spacious vehicles with experienced drivers provide comfortable travel for families with luggage."
  },
  {
    question: "Can I book a round-trip taxi from Mumbai to Solapur?",
    answer: "Yes, round-trip cab packages are available with flexible return schedules and customized travel plans."
  },
  {
    question: "Do you provide Mumbai to Solapur cabs for business travel?",
    answer: "Yes, our services are suitable for corporate meetings, industrial visits, official tours, and business requirements."
  },
  {
    question: "Can I customize my Mumbai to Solapur travel route?",
    answer: "Yes, you can customize your journey with planned stops and additional destinations according to your requirements."
  },
  {
    question: "Are overnight travel options available for Mumbai to Solapur?",
    answer: "Yes, overnight journeys can be arranged with experienced drivers for comfortable long-distance travel."
  },
  {
    question: "How is the Mumbai to Solapur cab fare calculated?",
    answer: "The fare depends on vehicle category, travel distance, trip duration, route, and additional travel requirements."
  },
  {
    question: "Can senior citizens travel comfortably by Mumbai to Solapur taxi?",
    answer: "Yes, our comfortable vehicles and professional chauffeurs make the journey convenient for senior citizens."
  },
  {
    question: "How can I book Mumbai to Solapur Cab with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger details, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ganesh Patil",
    feedback: "The Mumbai to Solapur cab service was smooth and reliable. The driver was professional, the vehicle was comfortable, and the complete journey was managed perfectly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Our family trip to Solapur was very comfortable with Shreesha Travels. The clean car and safe driving made our long journey easy and enjoyable.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Solapur Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-solapur-cab.webp",
  "description":
    "Book Mumbai to Solapur Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for one-way trips, round trips, business travel, family journeys, pilgrimage tours, and long-distance travel from Mumbai to Solapur with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-solapur-cab"
  }
};



    return (
        <div>

<Helmet>
  <title>Mumbai to Solapur Cab | One Way & Round Trip Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Solapur Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel, family trips, business journeys, and pilgrimage routes with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Solapur Cab, Mumbai to Solapur Taxi, Mumbai to Solapur Cab Service, Mumbai to Solapur Taxi Service, Mumbai to Solapur Cab Booking, Mumbai to Solapur Car Rental, Mumbai to Solapur Taxi Fare, Mumbai to Solapur One Way Cab, Mumbai to Solapur Round Trip Taxi, Mumbai to Solapur Outstation Cab, Mumbai Solapur Innova Cab, Mumbai Solapur Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/71.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitosolapurcab;